import './activity_drill_down_view.js.coffee';# Added by Script 
Customer.Views ||= {}
Customer.Views.Insights ||= {}

class Customer.Views.Insights.MyActivityDrillDownView extends Customer.Views.Insights.ActivityDrillDownView

  _openActivityDrillDownWindow: (event) ->
    event.preventDefault()
    $cell = $(event.currentTarget)
    window.open("/customer/my_activity/drilldown/#{$cell.data 'drilldown'}?#{@_urlQuery $cell}", '_blank')
